import Vue from 'vue'
import VueMeta from 'vue-meta'

Vue.use(VueMeta, {
  // This enables the title to be recalculated on every navigation change
  refreshOnceOnNavigation: true
})